import React from "react";

import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const FiltersContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  gap: "20px",
  alignItems: "center",
});

const Container = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "stretched",
})<{ stretched?: boolean }>(({ stretched }) => ({
  width: "100%",
  display: "flex",
  gap: "10px",
  alignItems: "center",
  // flexWrap:"wrap",
  // "& .MuiFormControl-root.MuiTextField-root":{
  //   width:"250px",
  // },
  ...(stretched &&
    {
      // justifyContent: "space-between",
    }),
}));

const QuickfiltersContainer = ({ children, stretched = true }: { children: React.ReactNode; stretched?: boolean }) => (
  <Container stretched={stretched}>{children}</Container>
);

export default QuickfiltersContainer;
